import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { PropertyCodeAcquireBookForm } from "@/features/propertyCodeAcquisition/components/PropertyCodeAcquireBookForm";
import { type PropertyInfoResponse } from "@/features/propertyCodeAcquisition/types";

// 不動産登記簿の取得ダイアログ。新規取得・再取得とも本ダイアログに集約する。

interface PropertyCodeAcquireDialogProps {
  open: boolean;
  /** 取得対象の物件情報（不動産種別・物件コードの取得元）。 */
  propertyInfo: PropertyInfoResponse;
  /** クローズ処理（キャンセル・取得成功時の自動クローズ）。 */
  onClose: () => void;
  /** 取得成功時のコールバック（履歴・物件情報の再取得など）。 */
  onAcquireSuccess: () => void;
}

const PropertyCodeAcquireDialogComponent: React.FC<
  PropertyCodeAcquireDialogProps
> = ({ open, propertyInfo, onClose, onAcquireSuccess }) => {
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        // 枠外クリック・Escキーでは閉じない。閉じる操作はフォーム内のキャンセルボタン
        // （送信中は無効化）と取得成功時の自動クローズに集約する。
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth="md"
      fullWidth
      aria-labelledby="property-code-acquire-dialog-title"
    >
      <DialogTitle id="property-code-acquire-dialog-title">
        不動産登記簿を取得する
      </DialogTitle>
      <DialogContent>
        <PropertyCodeAcquireBookForm
          propertyInfo={propertyInfo}
          onClose={onClose}
          onAcquireSuccess={onAcquireSuccess}
        />
      </DialogContent>
    </Dialog>
  );
};

/**
 * 取得フロー外のルート再レンダリング（履歴の再検証・タブ復帰時の SWR 再フェッチ等）で、
 * 開いている取得フォームが不要に再描画されるのを防ぐ。propertyInfo は SWR の deep-equal 比較で
 * 安定参照になる。
 */
export const PropertyCodeAcquireDialog = React.memo(
  PropertyCodeAcquireDialogComponent
);
